/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum Wealthlane_AwardService_Interfaces_Notices_NoticeGeneratorAwardType {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
}
